import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Portfolio from  './views/Portfolio.vue'
import DetailSection from './components/sections/portfolio/detailWhiteSectionPortfolio.vue'

Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        progress: {
          func: [
            { call: "color", modifier: "temp", argument: "#2869b8" },
            { call: "fail", modifier: "temp", argument: "#6e0000" },
            { call: "location", modifier: "temp", argument: "top" }
          ]
        }
      }
    },
    {
      path: "/portfolio",
      name: "portfolio",
      component: Portfolio,
      meta: {
        progress: {
          func: [
            { call: "color", modifier: "temp", argument: "#2869b8" },
            { call: "fail", modifier: "temp", argument: "#6e0000" },
            { call: "location", modifier: "temp", argument: "top" }
          ]
        }
      }
    },
    {
      path: "/portfolio/:id",
      name: "port",
      props: true,
      component: DetailSection,
      meta: {
        progress: {
          func: [
            { call: "color", modifier: "temp", argument: "#2869b8" },
            { call: "fail", modifier: "temp", argument: "#6e0000" },
            { call: "location", modifier: "temp", argument: "top" }
          ]
        }
      }
    }
  ]
});
